import { createMuiTheme } from "@material-ui/core";

const SPACING_UNIT = 4;
export const NUTRIENT_CONSUMPTION_ICON_SIZE = 28;

export const PRIMARY_COLOR = "#81bdcc";
export const PRIMARY_COLOR_LIGHT = "#b7dfe9";
export const ERROR_COLOR_LIGHT = "#d17e7e";
export const ERROR_COLOR = "#ca0f0f";
export const WARNING_COLOR = "#ecbe7e";
export const WARNING_COLOR_LIGHT = "#F9EBD8";
export const RED_COLOR_LIGHT = "#F1D8D8";
export const RED_COLOR = "#d17e7e";
export const PURPLE_COLOR = "#c7b4cc";
export const PURPLE_COLOR_LIGHT = "#EDE8EF";
export const GREEN_COLOR = "#b6d097";
export const GREEN_COLOR_LIGHT = "#E9F2DE";
export const BLUE_COLOR = "#68a4b6";
export const BLUE_COLOR_LIGHT = "#9fc5d1";
export const LIGHT_GRAY = "#EDEDED";
export const NEW_BLUE_COLOR = "#82BECC";
export const NEW_DARK_BLUE_COLOR = "#679099";

export const YELLOW_COLOR = "#F2C148";

export const DARK_RED = "#A75151";

export const ORANGE_COLOR = "#EF7A29";

export const GLOW_OPACITY = 77;

export const LOGIN_DROP_SHADOW = "0 12px 35px 0 rgba(0, 0, 0, 0.17)";
export const CARD_BORDER_RADIUS = SPACING_UNIT * 2;

export const DARK_TEXT_COLOR = "#222222";

export const NUTRIENT_RECOMMENDATION_GRADIENT_COLORS = {
  BAD: "#911B58",
  NEUTRAL: "#d8d8d8",
  GOOD: "#82becc",
};

export const CONTENT_MAX_WIDTH = 1440;
export const DIGITAL_TWIN_MAX_HEIGHT = 1000;

export const theme = createMuiTheme({
  spacing: SPACING_UNIT,
  typography: {
    fontFamily: "Navigo",
  },
  palette: {
    primary: {
      main: PRIMARY_COLOR,
      light: PRIMARY_COLOR_LIGHT,
      contrastText: "#ffffff",
    },
    secondary: {
      main: ORANGE_COLOR,
      light: ORANGE_COLOR,
      contrastText: "#ffffff",
    },
    text: {
      primary: DARK_TEXT_COLOR,
    },
    background: {
      default: "#f6f6f6",
    },
    error: {
      main: ERROR_COLOR,
      light: ERROR_COLOR_LIGHT,
    },
    warning: {
      main: WARNING_COLOR,
    },

    grey: {
      // @ts-ignore
      "100": "#ECECEC",
      "200": "#d8d8d8",
      "300": "#dce2f0",
      "500": "#b7b7b7",
      "800": "#333333",
    },
  },
  overrides: {
    MuiCard: {
      root: {
        borderRadius: CARD_BORDER_RADIUS,
      },
    },
    MuiButton: {
      root: {
        textTransform: "none",
      },
    },
  },
});
